import type { PublicCircleSortField } from "components/Slices/circleApiSlice";

// Sort options for public circles
export const SORT_OPTIONS: { value: PublicCircleSortField; label: string }[] = [
  { value: "monthlyContribution", label: "Contribution Amount" },
  { value: "maxMembers", label: "Members" },
];

// Default pagination limit
export const DEFAULT_PAGE_LIMIT = 20;

// Debounce delay for search input (ms)
export const SEARCH_DEBOUNCE_MS = 400;

